import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import Metrics from '~/types/Metrics';

export type AnalyticsState = {
  readonly metrics: Metrics;
  readonly isLoading: boolean;
};

const initialState: AnalyticsState = {
  metrics: [],
  isLoading: false,
};

function reducer(state: AnalyticsState = initialState, action: ActionTypes): AnalyticsState {
  switch (action.type) {
    case ActionKeys.ANALYTICS_FETCH_METRICS:
      return {
        ...state,
        metrics: [],
        isLoading: true,
      };
    case ActionKeys.ANALYTICS_FETCH_METRICS_SUCCESS:
      return {
        ...state,
        metrics: action.payload.metrics,
        isLoading: false,
      };
    case ActionKeys.ANALYTICS_FETCH_METRICS_ERROR:
      return {
        ...state,
        metrics: [],
        isLoading: false,
      };
    default:
      return state;
  }
}

export default reducer;
